import React from "react";
import { Link } from "react-router-dom";
import { X, Search, User, Heart, ShoppingCart } from "lucide-react";
import "../../../assests/css/customer/Sidebar.css";

const Sidebar = ({ isOpen, onClose, cartCount, wishlistCount, categories, activeTab, onCategoryClick, hasActiveSale }) => {
  return (
    <>
      {/* Overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? "active" : ""}`}
        onClick={onClose}
      ></div>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        {/* Close button */}
        <button className="sidebar-close-btn" onClick={onClose}>
          <X />
        </button>

        {/* Logo */}
        <div className="sidebar-logo">MOONLIT</div>

        {/* Navigation */}
     <nav className="sidebar-nav">
  <a href="/" className="sidebar-nav-item">Home</a>
  {categories.map((item) => (
    <a
      key={item.id}
      href={`/products/${item.category_name}`}
      className={`sidebar-nav-item ${activeTab === item.path ? "active" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        onCategoryClick(e, item);
      }}
    >
      {item.category_name}
    </a>
  ))}
 {hasActiveSale && (
  <Link
    to="/sale-products"
    className={`sidebar-nav-item ${activeTab === "/sale-products" ? "active" : ""}`}
    onClick={onClose}
  >
    Sale
  </Link>
)}
</nav>
        <Link to="/login" className="sidebar-register-btn" onClick={onClose}>
  Register
</Link>
      </div>
    </>
  );
};

export default Sidebar;